import { t } from '@lingui/macro';
import * as yup from 'yup';

const validationSchema = yup
  .object({
    account: yup.string(),
    dmsId: yup
      .string()
      .max(40, t`FMS ID must be at most 40 characters`)
      .matches(/^[a-zA-Z0-9]*$/, t`FMS ID must be alphanumeric only`),
    note: yup.string().max(350, t`Notes must be at most 350 characters`),
    name: yup.string().required(t`Name is required`),
    email: yup
      .string()
      .email()
      .required(t`Email is required`),
    address: yup.string(),
    city: yup.string().required(t`City is required`),
    state: yup.string().required(t`State is required`),
    postalCode: yup.string(),
    country: yup.string().required(t`Country is required`),
  })
  .required();

export default validationSchema;
